import { FormControl, InputAdornment, InputLabel, OutlinedInput } from '@mui/material'
import { FC } from 'react'
import { RoleType } from '../../redux/appReducer'
import { Flex } from './Helpers'

interface IProps {
    role: RoleType

    title: string
    firstValue: number
    secondValue: number
    firstOnChange(v: number): void
    secondOnChange(v: number): void
}

const OfferMarkup: FC<IProps> = props => {

    if (props.role !== 'company' && props.role !== 'admin') {
        return <></>
    }

    return (
        <Flex sx={{ mt: 2, justifyContent: 'space-between', gap: 2 }}>
            <FormControl variant="outlined" style={{ flexGrow: 1 }}>
                <InputLabel>{props.title}</InputLabel>
                <OutlinedInput
                    label={props.title}
                    startAdornment={<InputAdornment position="start">%</InputAdornment>}
                    type='number'
                    value={props.firstValue}
                    onChange={e => { props.firstOnChange(parseFloat(e.target.value)) }}
                    disabled={props.role === 'admin'}
                />
            </FormControl>
            {props.role === 'admin' ? <FormControl variant="outlined" style={{ flexGrow: 1 }} >
                <InputLabel>{props.title + ' 2'}</InputLabel>
                <OutlinedInput
                    label={props.title + ' 2'}
                    startAdornment={<InputAdornment position="start">%</InputAdornment>}
                    type='number'
                    value={props.secondValue}
                    onChange={e => { props.secondOnChange(parseFloat(e.target.value)) }}
                />
            </FormControl>
                : <></>}
        </Flex>
    )
}

export default OfferMarkup